import React, {useCallback, useContext, useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import {useHttp} from "../hooks/http.hook"
import config from '../config'
import {AuthContext} from '../context/AuthContext'
import {getAuthHeader, getItems, getLocalStorageItem, objectLang, setLocalStorageItem} from "../functions"
import {WindowPopup} from "../components/WindowPopup"
import {LoaderClass} from "../elements/LoaderClass"
import {LinksClass} from "../components/LinksClass";

export const GoogleDrivePropertiesPage = () => {
    setLocalStorageItem('page', 'GoogleDrivePropertiesPage')

    const auth = useContext(AuthContext)
    const { request, loading } = useHttp()
    const [allowed, setAllowed] = useState(true)
    const [fileData, setFileData] = useState(null)

    const lang = objectLang().language

    const host =
        window.location.host === 'localhost:3000'
            ? config.localHost
            : config.onrender

    const { fileId } = useParams()

    const getTypeColor = (type) => {
        switch(type) {
            case 'Folder': return '#1E90FF'
            case 'Word (.docx)':
            case 'Word (.doc)': return '#28a745'
            case 'Excel (.xlsx)':
            case 'Excel (.xls)': return '#fd7e14'
            case 'PowerPoint (.pptx)':
            case 'PowerPoint (.ppt)': return '#6f42c1'
            case 'PDF': return '#dc3545'
            case 'EXE': return '#6c757d'
            default: return '#000'
        }
    }

    const loadProperties = useCallback(async () => {
        if (!fileId) return

        try {
            const data = await request(
                `${host}/api/google-drive/detail`,
                'POST',
                {
                    redirectURI: window.location.origin,
                    fileId
                },
                {
                    Authorization: getAuthHeader(auth),
                    'Content-Type': 'application/json',
                }
            )

            if (data?.['newAccessToken']) {
                auth.login(data['newAccessToken'], auth.refreshToken)
            }

            setFileData({
                ...data,
                color: getTypeColor(data?.type),
                typeData: 'google-properties',
                thumb: new URLSearchParams(window.location.search).get('thumb') || '',
                fileType: new URLSearchParams(window.location.search).get('item') || ''
            })

        } catch (e) {
            setAllowed(false)
        }
    }, [fileId, auth, host, request])

    useEffect(() => {
        loadProperties().then()
    }, [loadProperties])

    if (!allowed) return <p>Access denied</p>

    if (loading) {
        return <LoaderClass />
    }

    return (
        <>
            <LinksClass
                auth={auth}
                documents={getLocalStorageItem('documents')}
                items={getItems(getLocalStorageItem('documents'))}
                rootFolder={auth.rootFolder}
            />
            {fileData && (
                <WindowPopup data={fileData} lang={lang} title={lang.body.googlePropertiesPage.title} onRename={null} />
            )}
        </>
    )
}